import EyekandyEventLogging from '../abstracts/EyekandyEventLogging'

class EyekandySyndicationLogging extends EyekandyEventLogging {
  constructor(options) {
    super(options)
    //
    //  Set the values from our current class.
    this.destination = 'syndication'
    this.syndicatedByAllInOne = false
  }

  preLogCallback(payload) {
    //
    //  Ok, now return the payload exactly as it will be sent.
    return payload
  }

  getLocalStorageKeyForABTest(service) {
    let value = null
    value = this.storageWrapper('local', `eky-ab-${service}`, 'get') || null
    return value
  }

  log(type, detail, service, arid) {
    //
    //  Always sent ARID as a string.
    if (arid) {
      arid = `${arid}`
    }
    //
    //  Define our logging payload.
    const payload = {
      type: type || null,
      detail: detail || null,
      service: service || null,
      arid: arid || null,
    }

    //
    //  :ab-testing:
    //  When A/B testing is enabled we need to read the A/B group from localstorage.
    //  TODO: The logic below means that the A/B group for any service on the page
    //        if it was syndicated by all-in-one - the A/B group for all-in-one is used.
    /*
    //
    //  @Louis: Removed as this is v1 code.
    let abGroup = null
    if (this.syndicatedByAllInOne) {
      //
      //  When marked as syndicated by all-in-one, we need to upsert the A/B group.
      abGroup = this.getLocalStorageKeyForABTest("all-in-one")
    } else {
      //
      //  We can just read using the current service name.
      abGroup = this.getLocalStorageKeyForABTest(service)
    }
    // 
    //  If we read a value for the abGroup, add it to our payload.
    if (abGroup) {
      payload.ab = abGroup
    }
    */

    //
    //  :a/b-tests-v2:
    //  When an A/B test is running it'll mark window, check to see if it's there.
    if (window.EKY_AB_TEST_DETAILS) {
      payload.ab = window.EKY_AB_TEST_DETAILS
      //
      //  TODO: Fix this hack for Intel April 2023.
      if (payload.type === 'delivery') {
        if (payload.ab.charAt(0) === 'b' && payload.ab.includes('1b947')) {
          payload.type = 'notification'
        }
      }
    }

    //
    //  Send the log out.
    return this._log(payload)
  }

  updateDistributor(distributor) {
    this.distributor = distributor
  }

  updateLanguage(language) {
    this.language = language
  }

  updateEnvironment(environment) {
    this.environment = environment
  }

  setSyndicatedByAllInOne() {
    this.syndicatedByAllInOne = true
  }
}

//
//  :exports:
export default EyekandySyndicationLogging
